import styled, { css } from 'styled-components'
import { white } from '../../theme/colors'
import { spacing_1, spacing_2, spacing_4, spacing_6 } from '../../theme/spacing';
import { xsMd } from '../../theme/utils/media-query';

export function makeLayout (element) {
  return styled(element)`
    background: ${props => props.bgColor || white};
    display: flex;
    justify-content: ${props => props.justifyContent || 'center'};
    align-items: ${props => props.alignItems || 'center'};
    flex-direction: ${props => props.flexDirection || 'row'};
    padding: ${props => props.padding || `${spacing_6} ${spacing_2}`};

    ${xsMd(css`
      {
        padding: ${props => props.paddingMobile || props.padding || `${spacing_4} ${spacing_1}`};
      }
    `)}
  `
}

export default makeLayout